export const ADMIN = 'admin'
export const SUPERVISOR = 'supervisor'
export const PORTAL_CREATOR = 'portal_creator'



// WEBPACK FOOTER //
// ./src/constants/roles.js